export default "__VITE_ASSET__BYqs3fYg__"